/* eslint-disable class-methods-use-this, prefer-destructuring, no-use-before-define, no-shadow */
class Header {
  constructor() {
    this.header = document.getElementById("header");
    this.initHeader();
    this.searchForm();
  }

  initHeader() {
    const header = this.header;
    const headerHeight = header.offsetHeight;
    const main = document.getElementsByClassName("barba-container")[0];
    const mobileMenuToogler = document.getElementById("main-menu-toggler");
    const menuItems = document.querySelectorAll(".menu-item");
    const subMenus = header.querySelectorAll(".sub-menu");
    let distanceToTop = document.documentElement.scrollTop;
    let changeMenuOpacity = true;

    // menu mobile

    if (subMenus !== null) {
      try {
        const menuItemHasChildren = document.querySelectorAll(
          ".menu-item-has-children"
        );
        const goBackBttn = header.querySelector(".menu__go-back--bttn");
        const texGgoBackBttn = goBackBttn.textContent;

        document.querySelectorAll("ul.sub-menu").forEach(function (ul) {
          const li = document.createElement("li");
          li.className = "submenu-item-go-back";
          // Aquí puedes añadir más propiedades al li si es necesario
          ul.insertBefore(li, ul.firstChild);
          const submenuGoBack = ul.firstChild;
          if (submenuGoBack.classList.contains("submenu-item-go-back")) {
            submenuGoBack.innerText = texGgoBackBttn;
            submenuGoBack.addEventListener("click", function () {
              submenuGoBack.parentElement.parentElement.classList.remove(
                "menu-item-has-children--active"
              );
              submenuGoBack.parentElement.parentElement.classList.remove(
                "submenu-item-has-children--active"
              );
            });
          }
        });

        if (menuItemHasChildren) {
          menuItemHasChildren.forEach((menuItem) => {
            const span = document.createElement("span");
            span.className = "open-submenu--button";
            menuItem.appendChild(span);
            menuItem.lastChild.addEventListener("click", function () {
              this.parentElement.classList.add(
                "menu-item-has-children--active"
              );
            });
          });
        }

        goBackBttn.remove();
      } catch (err) {
        console.log(err.message);
      }
    }

    // Menu items event listener
    menuItems.forEach((menuItem) => {
      if (menuItem.children[0].tagName === "A") {
        menuItem.children[0].addEventListener("click", menuItemScrollToggle);
      }
    });

    // Menu button event listener
    if (mobileMenuToogler) {
      mobileMenuToogler.addEventListener("click", windowScrollToggle);
    }

    // Scroll event listener
    window.addEventListener("scroll", throttle(callback, 200));

    if (distanceToTop > 0) {
      header.classList.add("scrolled");
    }

    // Window scroll toggle
    function windowScrollToggle() {
      const body = document.body;

      if (body.classList.contains("u-mobile-block-scroll")) {
        body.classList.remove("u-mobile-block-scroll");
      } else {
        body.classList.add("u-mobile-block-scroll");
      }
    }

    // Menu item window scroll toggle
    function menuItemScrollToggle() {
      if (!this.classList.contains("menu-item-has-children")) {
        windowScrollToggle();
      }

      mobileMenuToogler.checked = false;
    }

    function throttle(callback, wait = 100) {
      let timer = null;

      return (args) => {
        if (timer === null) {
          timer = setTimeout(() => {
            callback.apply(this, args);
            timer = null;
          }, wait);
        }
      };
    }

    function callback() {
      const newDistanceToTop = document.documentElement.scrollTop;

      if (newDistanceToTop > headerHeight) {
        if (changeMenuOpacity === true) {
          header.style.opacity = 0;
          changeMenuOpacity = false;
        }

        header.classList.add("scrolled");
        main.style.marginTop = `${headerHeight}px`;
      }

      if (newDistanceToTop < distanceToTop) {
        header.classList.add("scrolled--show");
        header.style.opacity = 1;
      } else {
        header.classList.remove("scrolled--show");
      }

      if (newDistanceToTop === 0) {
        header.classList.remove("scrolled", "scrolled--show");
        main.style.marginTop = 0;
        changeMenuOpacity = true;
      }

      distanceToTop = newDistanceToTop;
    }

    // Set a CSS variable to fix Webkit-based mobile phones handling of vh units.
    // You can use it with the vh() SASS function.
    function setCSSvh() {
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight}px`
      );
    }

    // remove transitions header resize window

    const classes = header.classList;
    let timer = 0;
    window.addEventListener("resize", () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      } else classes.add("stop-transitions");

      timer = setTimeout(() => {
        classes.remove("stop-transitions");
        timer = null;
      }, 100);
    });

    window.addEventListener("resize", setCSSvh);
    window.addEventListener("orientationchange", setCSSvh);
    setCSSvh();

    // submenu behaviour

    const submenusSubmenu = document.querySelectorAll(".sub-menu .sub-menu");
    const submenus = document.querySelectorAll(".sub-menu");

    if (submenusSubmenu) {
      submenusSubmenu.forEach((subSubmenu) => {
        const subMenuItem = subSubmenu.parentNode;
        const subMenu = subMenuItem.parentNode;

        subMenuItem.addEventListener("mouseover", () => {
          subMenu.style.height = `${subSubmenu.clientHeight}px`;
          subMenuItem.classList.add("sub-menu--active");
        });
        subMenuItem.addEventListener("mouseout", () => {
          subMenu.style.height = "";
          subMenuItem.classList.remove("sub-menu--active");
        });
        subMenu.addEventListener("click", () => {
          subMenu.classList.add("sub-menu--hide");
        });
        document.addEventListener("scroll", () => {
          subMenu.classList.add("sub-menu--hide");
        });
        subMenu.previousElementSibling.addEventListener("mouseover", () => {
          subMenu.classList.remove("sub-menu--hide");
        });
      });
    }

    if (submenus) {
      submenus.forEach((submenu) => {
        submenu.addEventListener("click", () => {
          submenu.classList.add("sub-menu--hide");
        });
        document.addEventListener("scroll", () => {
          submenu.classList.add("sub-menu--hide");
        });
        submenu.previousElementSibling.addEventListener("mouseover", () => {
          submenu.classList.remove("sub-menu--hide");
        });
      });
    }
  }

  searchForm() {
    const body = document.body;
    const header = this.header;
    const searchFormButton = document.querySelectorAll(
      ".js-search-button a"
    )[0];
    const searchForm = document.getElementsByClassName(
      "search-form--header"
    )[0];
    const searchFormInput =
      document.getElementsByClassName("search-form__input")[0];

    function showSearchForm(form) {
      const searchForm = form;
      body.classList.add("searchForm");
      header.classList.add("scrolled--show");
      header.classList.add("scrolled");
      searchForm.style.display = "block";
      searchForm.setAttribute("aria-expanded", "true");
      searchFormInput.focus();
    }

    function hideSearchForm() {
      searchForm.style.display = "none";
      body.classList.remove("searchForm");
      header.classList.remove("scrolled--show");
      header.classList.remove("scrolled");
      searchForm.setAttribute("aria-expanded", "false");
    }

    function searchFormToggle(event) {
      event.preventDefault();

      if (searchForm.style.display === "block") {
        hideSearchForm();
      } else {
        showSearchForm(searchForm);
      }
    }

    // Remove transitions header resize window.

    const classes = header.classList;

    let timer = 0;
    window.addEventListener("resize", () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      } else classes.add("stop-transitions");

      timer = setTimeout(() => {
        classes.remove("stop-transitions");
        timer = null;
      }, 100);
    });

    // Add Barba prevent class to search link
    searchFormButton.classList.add("js-barba-prevent");

    // Toggle search form
    if (searchFormButton && searchForm && searchFormInput) {
      // Toggle search form when clicking search button
      searchFormButton.addEventListener("click", searchFormToggle);

      // Hide search form when clicking outside or when tabbing or escaping out of the search bar.
      searchFormInput.addEventListener("keydown", (event) => {
        // Esc: 27.
        if (event.keyCode === 27) {
          hideSearchForm();
        }
      });
    }
  }
}

export default Header;
